const mutations = {
  onGet (state, payload) {
    payload.event.context.sites = payload.response.data.data.data
    if (payload.event.context.options && !payload.event.all) {
      payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
      payload.event.context.options.page = payload.response.data.data.current_page
      payload.event.context.options.total = payload.response.data.data.total
      payload.event.context.loadTable = false
    }
  },
  onPost (state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onPut (state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.close()
    payload.event.context.get()
  },
  onDeleteUser (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.removeUserDialog = false
    payload.event.context.loading = false
    payload.event.context.editedItem.users.splice(payload.event.item.user.index, 1)
    payload.event.context.get()
  },
  onAddUsers (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.close()
    payload.event.context.get()
  },
  onGetById (state, payload) {
    payload.event.context.editedItem = payload.response.data.data
    payload.event.context.editedItem.email = payload.event.context.editedItem.email ? payload.event.context.editedItem.email : ''
    payload.event.context.editedItem.manager = payload.event.context.editedItem.manager ? payload.event.context.editedItem.manager : ''
    payload.event.context.editedItem.phone = payload.event.context.editedItem.phone ? payload.event.context.editedItem.phone : ''
    payload.event.context.editedItem.additional_info = payload.event.context.editedItem.additional_info ? payload.event.context.editedItem.additional_info : ''
    payload.event.context.loadItem = false
  },
  onGetByUser (state, payload) {
    payload.event.context.sites = payload.response.data.data;
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  }
}

export default mutations